module.exports = __webpack_public_path__ + "img/digital-signature.842c8ec9.png";